// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-upload__files-list__file {
  padding: 5px 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;
}
.file-upload__files-list__file .file-upload__files-list__file__icon-wrapper--failed, .file-upload__files-list__file .file-upload__files-list__file__icon-wrapper--loading {
  height: 50px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.file-upload__files-list__file__icon-wrapper--failed {
  font-size: 18pt;
  color: #bd362f;
}
.file-upload__files-list__file .close {
  display: none;
  position: absolute;
  top: 0;
  right: 10px;
}
.file-upload__files-list__file:hover .close {
  display: block;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/FileUpload/FileUpload.scss"],"names":[],"mappings":"AAEQ;EACI,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,mBAAA;AADZ;AAGY;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADhB;AAQY;EAEI,eAAA;EACA,cAAA;AAPhB;AAUY;EACI,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AARhB;AAYgB;EACI,cAAA;AAVpB","sourcesContent":[".file-upload {\n    &__files-list {\n        &__file {\n            padding: 5px 10px;\n            display: flex;\n            flex-direction: row;\n            flex-wrap: nowrap;\n            justify-content: flex-start;\n            align-items: center;\n\n            %loading-wrapper {\n                height: 50px;\n                width: 50px;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n            }\n\n            &__icon-wrapper--loading {\n                @extend %loading-wrapper;\n            }\n\n            &__icon-wrapper--failed {\n                @extend %loading-wrapper;\n                font-size: 18pt;\n                color: #bd362f;\n            }\n\n            .close {\n                display: none;\n                position: absolute;\n                top: 0;\n                right: 10px;\n            }\n\n            &:hover {\n                .close {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
